import { useEffect, useState } from "react";
import UseTranslationHook from "../../hooks/UseTranslationHook";
import {
  getAllSubscriptionPackage,
  getSubscriptionPackageFields,
  ISubscriptionPackage,
} from "./SubscriptionPackageViewController";
import { eyeIcon } from "../../assets/icons/SvgIconList";
import { AdvanceSearch, ICTable } from "../../core-component/ui";
import SubscriptionPackageForm from "./SubscriptionPackageForm";

let timer: ReturnType<typeof setTimeout>;

const SubscriptionPackageView = () => {
  const { t } = UseTranslationHook();
  const [isLoading, setIsLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [subscriptionPackageList, setSubscriptionPackageList] = useState<
    ISubscriptionPackage[]
  >([]);
  const [subscriptionPackageToView, setSubscriptionPackageToView] =
    useState<ISubscriptionPackage>();
  useEffect(() => {
    fetchSubscriptionPackage();
  }, []);

  const fetchSubscriptionPackage = () => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(async () => {
      setIsLoading(true);
      await getAllSubscriptionPackage(setSubscriptionPackageList);
      setIsLoading(false);
    }, 500);
  };
  const customActionView = (item: ISubscriptionPackage) => {
    return (
      <div className="flex item-center justify-center w-full">
        <div
          className="size-5 cursor-pointer"
          title={t("view_tooltip_icon")}
          onClick={() => {
            setSubscriptionPackageToView(item);
            setShowForm(true);
          }}
        >
          {eyeIcon}
        </div>
      </div>
    );
  };
  return (
    <div className="w-full overflow-scroll scrollbar-remove p-4">
      <AdvanceSearch
        refreshTable={() => {
          fetchSubscriptionPackage();
        }}
        title={t("subscription_package")}
      />
      <ICTable<ISubscriptionPackage>
        isLoading={isLoading}
        totalFlex="grid grid-cols-10"
        fields={getSubscriptionPackageFields(customActionView, t)}
        data={subscriptionPackageList}
        handleChangePerPageRows={(perPageRow) => fetchSubscriptionPackage()}
        handleChangePage={(page) => fetchSubscriptionPackage()}
        handleSort={(field) => fetchSubscriptionPackage()}
      />
      {showForm && subscriptionPackageToView && (
        <SubscriptionPackageForm
          handleClose={() => setShowForm(false)}
          subscriptionPackageToView={subscriptionPackageToView}
        />
      )}
    </div>
  );
};

export default SubscriptionPackageView;
